import { Card } from "@/components/ui/card";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";

export const KpiCard = ({ label, value, delta, hint, onClick, active, testid }) => (
  <Card
    onClick={onClick}
    data-testid={testid}
    className={`p-4 md:p-5 cursor-pointer transition-colors ${active ? "border-[hsl(var(--hi-gold)/0.5)] bg-[hsl(var(--hi-gold-soft)/0.4)]" : "hover:bg-accent/40"}`}
  >
    <div className="flex items-center justify-between">
      <span className="text-xs uppercase tracking-wider text-muted-foreground">{label}</span>
      {typeof delta === "number" && (
        <span className={`inline-flex items-center gap-0.5 text-xs font-medium rounded-full px-1.5 py-0.5 ${delta >= 0 ? "text-[hsl(var(--hi-status-success))] bg-[hsl(var(--hi-status-success)/0.12)]" : "text-destructive bg-destructive/10"}`}>
          {delta >= 0 ? <ArrowUpRight className="h-3 w-3" /> : <ArrowDownRight className="h-3 w-3" />}
          {Math.abs(delta)}%
        </span>
      )}
    </div>
    <div className="mt-2 font-heading text-2xl md:text-3xl font-semibold tabular">{value}</div>
    {hint && <div className="mt-1 text-xs text-muted-foreground">{hint}</div>}
  </Card>
);
